import { createContext, useContext, useMemo, useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getBlogs, deleteBlog } from "../../api/blogs";
import * as pageAPI from "../../api/home";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import { updateBlog } from "../../api/home";
import { getIntialValues, generatePayload } from "./helper";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const navigate = useNavigate();

  const [term, setTerm] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const getBlogsQuery = useQuery({
    queryKey: ["blogs", term],
    queryFn: () => getBlogs({ queryKey: [{ term, limit: 500 }] }),
  });

  const getBlogsContentQuery = useQuery({
    queryKey: ["blogContent", term],
    queryFn: pageAPI.getBlog,
  });

  const updateBlogQuery = useMutation({ mutationFn: updateBlog });
  const deleteBlogQuery = useMutation({ mutationFn: deleteBlog });

  const initialValues = useMemo(() => {
    const homeData = getBlogsContentQuery?.data?.data?.data?.[0] || {};
    return getIntialValues(homeData.page_content);
  }, [getBlogsContentQuery]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    const homeData = getBlogsContentQuery?.data?.data?.data?.[0] || {};

    updateBlogQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {

          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY || "Updated successfully");

          getBlogsContentQuery.refetch();
        },
        onError: () => {
          toaster.error("Error", "Failed to update data");
        },
      }
    );
  };

  const handleWorkDelete = (item) => {
    setSelectedBlog(item);
    setShowDeleteModal(true);
  };

const handleConfirmDelete = () => {
  if (!selectedBlog) return;

  deleteBlogQuery.mutate(selectedBlog.id, {
    onSuccess: (res) => {

      getBlogsQuery.refetch();

      toaster.success(Const.MESSAGES.SUCCESS, "Blog deleted successfully.");

      setShowDeleteModal(false);
      setSelectedBlog(null);
    },
    onError: (err) => {

      toaster.error(
        "Error",
        err?.response?.data?.error || "Failed to delete blog"
      );
    },
  });
};

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedBlog(null);
  };

  const handleAddBlogClick = () => {
    navigate("/add-blog");
  };

  const handleEditClick = (item) => {
    navigate(`/add-blog?id=${item.id}`);
  };

  const handleOnChange = (e) => {
    setTerm(e.target.value);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        getBlogsQuery,
        handleWorkDelete,
        handleAddBlogClick,
        handleEditClick,
        handleOnChange,
        term,
        handleSubmit,
        showDeleteModal,
        handleConfirmDelete,
        handleCancelDelete,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};